import { Link } from "@tanstack/react-router";
import { TeaserImage } from "./TeaserImage";
import { Button } from "./ui/button";
import { cn } from "~/lib/utils";
import { ChevronRight } from "lucide-react";

interface CtaButtonsProps {
  align?: "left" | "center";
  link: string;
  ctaLabel: string;
  ctaLabelColor?: string;
  secondaryLink?: string;
  secondaryCtaLabel?: string;
}

export const CtaButtons = ({
  align = "left",
  link,
  ctaLabel,
  ctaLabelColor,
  secondaryLink,
  secondaryCtaLabel,
}: CtaButtonsProps) => {
  if (!(link && ctaLabel) && !(secondaryLink && secondaryCtaLabel)) {
    return null;
  }

  return (
    <div
      className={cn("flex gap-4", align === "center" ? "justify-center" : "")}
    >
      {link && ctaLabel && (
        <Button
          variant={ctaLabelColor === "black" ? "black" : "default"}
          asChild
          size={"lg"}
        >
          <Link to={link} className="flex items-center gap-1">
            {ctaLabel}
          </Link>
        </Button>
      )}
      {secondaryLink && secondaryCtaLabel && (
        <Link
          className="flex items-center gap-1 font-medium hover:underline"
          to={secondaryLink}
        >
          {secondaryCtaLabel} <ChevronRight />
        </Link>
      )}
    </div>
  );
};
